import { GetterTree } from 'vuex'
import { IUserState, EDeveloperStatus } from './types'

const getters: GetterTree<IUserState, any> = {
  isLogin (state: IUserState) {
    return !!(state.userInfo && state.userInfo.userid)
  },

  userInfo (state: IUserState) {
    return state.userInfo || {}
  },

  isDeveloper (state: IUserState, getters) {
    return getters.isLogin && ((getters.userInfo.developer && getters.userInfo.developer.developer_id) || (getters.curEnterprise && getters.curEnterprise.developer_id))
  },

  isPassedDeveloper (state: IUserState, getters) {
    return getters.isDeveloper && getters.curEnterprise.status === EDeveloperStatus.PASSED
  },

  isPassedEnterprise (state: IUserState, getters) {
    return getters.isDeveloper && ((getters.curEnterprise.developer_type === 1) || (getters.curEnterprise.developer_type !== 1 && getters.curEnterprise.status === EDeveloperStatus.PASSED))
  },

  isPendingDeveloper (state: IUserState, getters) {
    return getters.isDeveloper && getters.userInfo.developer.status === EDeveloperStatus.PENDING
  },

  isRejectedDeveloper (state: IUserState, getters) {
    return getters.isDeveloper && getters.userInfo.developer.status === EDeveloperStatus.REJECTED
  },

  curEnterprise (state: any) {
    return state.curEnterprise
  },

  developerList (state: any) {
    return state.developerList
  }
}

export default getters
